<template>
  <div class="ovip-container">
    <navigation :customClickEvent="true" @click="detention" arrTheme='grey' :theme="{
      background: '#43476B',
      color: '#fff'
    }"
    >
      <span>小美VIP会员</span>
      <span slot="right" class="rule-txt" :class="!showPoint&&'point'"
            @click="jumpRule"
      > 规则说明</span>
    </navigation>
    <van-tabs
      v-model="active"
      line-width="84"
      line-height="4"
      background='#43476B'
      color="#FFD8BCFF"
      title-active-color="#FFD8BCFF"
      title-inactive-color="#fff" 
      :sticky="true"
      class="tabs"
      v-if="!isVip"
      :offset-top="128"
    >
      <van-tab title="月卡">
      </van-tab>
      <van-tab title="半年卡">
      </van-tab>
      <van-tab title="年卡">
      </van-tab>
    </van-tabs>
    <pulldown-page
      class="page"
      background="#1C2032"
      :refresh="init"
      :isScroll='true'
    >
      <div :class="[{isVip: isVip}]">
        <div class="main-container">
          <div class="order-title" v-if="isVip">
            <span >我的订单</span>
            <a @click="toOrderList">查看订单 ></a>
            <img src="../../assets/images/icon_kefu@2x.png" class="order-service" @click="handleJumpService">
          </div>
          <div class="equity-container" >
            <template v-if="isVip">
              <div class="user-container">
                <img :src="iconVipHead">
                <div class="user-info">
                  <b>{{detail.maskMobile}}</b>
                  <p v-if="detail.memberStatus === 'NORMAL'">{{detail.expireDate}}到期</p>
                  <p v-if="detail.memberStatus === 'EXPIRED'">{{detail.expireDate}}会员已失效</p>
                </div>
              </div>
              <span class="icon_vip" v-if="detail.memberStatus === 'NORMAL'">{{vipsName[detail.memberType]}}VIP</span>
              <span class='vip-btn' v-if="detail.memberStatus === 'EXPIRED'" @click="dialog.vipPast=true">立即续费</span>
            </template>
            <template v-else>
              <h2>{{detail.memberDesc}}</h2>
              <p class="desc">每日仅需{{detail.dayOfPay}}元，享{{detail.equityCount}}项权益，立省{{detail.saveAmt}}元</p>
            </template>
                
            <div class="equity-items">
              <div class="item" v-for="(item,index) in detail.equityList || []" :key="index">
                <img :src="`${item.icon}?v=1.74`" class="icon" />
                <p>{{item.equityName}}</p>
                <span>{{item.equityDesc}}</span>
              </div>
            </div>
          </div>
              
          <!-- 金融权益 -->
          <div class="finance-equity"  v-if="detail.financeEquityList && detail.financeEquityList.length">
            <div class="ui-title">
              <i /> 金融权益 <i /> 
            </div>
            <div class="finance-equity-items">
                
              <div class="item" v-for="(item,index) in detail.financeEquityList || []" :key="index" >
                <div class="info-left">
                  <img :src="iconVip01" class="icon" v-if="item.memberCouponType==='COUPON'" />
                  <img :src="iconVip02" class="icon" v-if="item.memberCouponType==='CASH'" />
                  <img :src="iconVip03" class="icon" v-if="item.memberCouponType==='LIMIT'" />
                  <div class="info-container">
                    <span class="title">{{item.couponName}}</span>
                    <p  >
                      <template v-if="!isVip">{{item.couponDesc}} </template>
                      <template v-if="isVip && item.memberCouponType !=='CASH'">
                        专享{{item.useLimitAmt}}元{{item.useTimes}}次
                        剩{{item.remainUseTimes}}次
                      </template>
                            
                      <template v-if="item.memberCouponType==='CASH' && ['NORMAL','EXPIRED'].includes(detail.memberStatus) ">{{item.discountValue}}元</template>
                    </p>
                  </div>
                </div>
                <template v-if="isVip">
                  <!-- 免息红包 -->
                  <div class="control" v-if="item.memberCouponType==='COUPON'" @click="showWelfare(item.memberCouponType, item)">
                    <i class="tips" v-if="item.yellowRemark">
                      {{item.yellowRemark}}
                    </i>
                    <span v-if="item.memberCouponStatus==='RECEIVED' && !['LOANING','LOAN_LOCKED','REPAY', 'REPAYING'].includes(item.useAction)">去使用 > </span>
                    <span v-if="item.memberCouponStatus==='RECEIVED' && ['LOANING','LOAN_LOCKED','REPAY', 'REPAYING'].includes(item.useAction)">去查看 > </span>
                    <span v-if="['USE_FAIL','USED','TIMEOUT','USEING'].includes(item.memberCouponStatus)">去查看 ></span>
                  </div>
                  <!-- 赔付红包 -->
                  <div class="control" v-if="item.memberCouponType==='CASH'"  @click="showWelfare(item.memberCouponType, item)">
                    <i class="tips" v-if="!['NORMAL','EXPIRED'].includes(detail.memberStatus)">
                      最高{{item.discountAmt}}元
                    </i>
                    <span>
                      去查看 >  
                    </span>
                  </div>
                        
                  <!-- 提额 -->
                  <div class="control" v-if="item.memberCouponType==='LIMIT'" @click="showWelfare(item.memberCouponType, item)">
                    <i class="tips"  v-if="item.yellowRemark"> {{item.yellowRemark}} </i>
                    <span v-if="item.memberCouponStatus==='RECEIVED'">申请提额 ></span>
                    <span v-if="item.memberCouponStatus==='FREEZE'">本次资格已过期 </span>
                    <span v-if="item.memberCouponStatus==='USING'">提额申请中... </span>
                    <span v-if="['USED', 'TIMEOUT'].includes(item.memberCouponStatus)">去查看 ></span>
                    <span v-if="item.memberCouponStatus==='USE_FAIL'">提额失败 </span>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <!-- 生活权益 -->
          <div class="finance-equity">
            <div class="ui-title">
              <i /> 生活权益 <i /> 
            </div> 
            <!-- 免费热门会员 -->
            <div class="mini-title">免费热门会员<span class="small">（每月10选1）</span></div>
            <swiper :list="detail.freeHotEquityList || []" tapType="hot" :vipStatus='detail.memberStatus' @show-pass="dialog.vipPast=true" :isVip="isVip" @show-welfare="showWelfare"/>
            <!-- 5折出行优惠 -->
            <div class="mini-title mt50">5折出行优惠<span class="small">（每月3选1）</span></div>
            <swiper :list="detail.travelEquityList || []" tapType="trip" :vipStatus='detail.memberStatus' @show-pass="dialog.vipPast=true" :isVip="isVip" @show-welfare="showWelfare"/>
            <!-- 更多优惠 -->
            <div class="mini-title mt50">更多优惠</div>
            <div class="more-container">
              <img class="more-img" @click="linkUrl(item.linkUrl,item.equityCode)" :src="`${item.icon}?v=1.74`" v-for="(item,index) in detail.otherEquityList" :key="index">
            </div>
            <div class="more-tips mt50">
              更多福利 敬请期待…
            </div>
            <refund-box :member-no="memberNo" :refund-data="refundData"></refund-box>
          </div>

        </div>
        <div class="btn-container" v-if="!isVip">
          <nd-button class="continue-btn" @click="buy(active)">
            <span class="line-through ">原价 ¥{{detail.originalPrice}}</span>
            <span>&nbsp;&nbsp; 开通仅需 ¥{{detail.discountPrice}}</span>
          </nd-button>
          <span class="ui-bubble">限时特价</span>
          <div class="xy-tips"><span class="text">开通即同意</span><span class="xy-active" @click="routerToVipProtocol">《小美VIP会员用户协议》</span></div>
        </div>
        <!-- 弹窗/会员过期 -->
        <nd-dialog
          v-model="dialog.vipPast"
          :footer="false"
          closeBtn
          class="activity-dialog"
        >
          <div class="activity-template-content" >
            <div class="title">您的小美VIP会员已过期</div>
            <div class="content">
              <span v-if="vipInfomation.expireDays ">您的会员身份已过期{{vipInfomation.expireDays }}天，</span>小美已为您累计节省{{vipInfomation.popSaveAmt}}元。 
              <p>小美VIP全新升级，权益加量不加价，享超100项权益，金融/生活出行样样省！</p>
            </div> 
            <!-- <div class="check-more" @click="$router.push('/vip/preindex?stash=true')">查看更多福利 ></div> -->
            <!-- <div class="vips">
                      <div @click="buyVipLv=index" :class="['item', {active: buyVipLv==index}]" v-for="(item,index) in vipInfomation.simpleList" :key="item.lv">
                        <img :src="iconVip" class="vipIcon" >
                        <p>
                          {{vipsName[item.memberType]}} ￥{{item.discountPrice}}<br>
                          <span class="line-through yj">原价￥{{item.originalPrice}}</span>
                        </p>
                      </div>
                    </div> -->
            <div class="button-group">
              <nd-button class="btn" @click="$router.push('/vip/preindex?stash=true')">立即前往 </nd-button>
              <div class="xy-tips" >开通即同意 <span class="active" @click="routerToVipProtocol">《小美VIP会员协议》</span> </div>
                      
            </div>
          </div>
        </nd-dialog>

        <!-- 弹窗/返回挽留 -->
        <nd-dialog
          v-model="dialog.detention"
          :footer="false"
          closeBtn
          class="activity-dialog cat"
        >
          <div class="activity-template-content " >
            <div class="title">放弃小美VIP，一年将损失￥{{vipInfomation.popLoseAmt}}</div>
            <div class="content">
              <p >
                现在成为会员，享8项专属特权；
                吃喝玩乐出行样样省心；
                提现享超值福利！
              </p>
            </div> 
            <div class="button-group">
              <nd-button class="btn" @click="buy(active,'detention')">立即领取 </nd-button>
              <div class="giveup-btn" @click='back'>不想省钱了 </div>
            </div>
          </div>
        </nd-dialog>

        <!-- 弹窗/无有效额度时，免息券授信引导 -->
        <nd-dialog
          v-model="dialog.coupon"
          :footer="false"
          closeBtn
          class="activity-dialog"
        >
          <div class="activity-template-content" >
            <div class="title">当前暂无额度 <br> 仅需3步，获得免息返现</div>
            <div class="content">
              <div class="step">
                <p><i class="line">1</i> 获得授信额度</p>
                <p><i class="line">2</i> 完成1笔借款</p>
                <p><i>3</i> 该订单倒数{{n}}期正常还款</p>
              </div>
            </div> 
            <div class="button-group">
              <nd-button class="btn"  @click="toCredit('COUPON')">去授信 {{time>0?'('+time+'s)':''}}</nd-button>
            </div>
          </div>
        </nd-dialog>

        <!-- 弹窗/无有效额度时，额度券授信引导 -->
        <nd-dialog
          v-model="dialog.quota"
          :footer="false"
          closeBtn
          class="activity-dialog cat"
        >
          <div class="activity-template-content " >
            <div class="title">暂无额度，当前不能提额</div>
            <div class="content">
              <p>需先获得授信额度后，再发起提额申请</p>
            </div> 
            <div class="button-group">
              <nd-button class="btn"  @click="toCredit('LIMIT')">去授信 {{time>0?'('+time+'s)':''}}</nd-button>
            </div>
          </div>
        </nd-dialog>

        <!-- 弹窗/未开通时—权益介绍弹窗 -->
        <nd-dialog
          v-model="dialog.welfare"
          :footer="false"
          closeBtn
          class="activity-dialog "
        >
          <div class="activity-template-content " >
            <div class="title">{{welfares[welfareType].name}} <span class="ui-bubble" v-if="welfares[welfareType].max">{{welfares[welfareType].max}}</span></div>
            <div class="content">
              <p v-html="welfares[welfareType].desc"></p>
            </div> 
            <div class="button-group">
              <nd-button class="btn" @click="buy(active,'welfare')">立即领取</nd-button>
              <div class="xy-tips" >领取即同意 <span class="active" @click="routerToVipProtocol">《小美VIP会员协议》</span> </div>
                    
            </div>
          </div>
        </nd-dialog>

        <!-- 弹窗/有会员状态在支付中 -->
        <nd-dialog
          v-model="dialog.waitPay"
          :footer="false"
          closeBtn
          class="activity-dialog "
        >
          <div class="activity-template-content " >
            <div class="title">温馨提示</div>
            <div class="content">
              <p>您有一笔未完成的{{vipsName[payStatusInfo.memberType]}}{{['SC_HY','SC1_HY'].includes(payStatusInfo.memberType)?'SVIP':'VIP'}}支付交易</p>
            </div> 
            <div class="button-group">
              <nd-button class="btn" @click="jump(vipActive[payStatusInfo.memberType],payStatusInfo.payAmt)">继续支付</nd-button>
              <div class="giveup-btn" @click='giveup'>放弃支付 </div>
            </div>
          </div>
        </nd-dialog>

        <!-- IOS 版本过低提示升级 -->
        <nd-dialog
          v-model="dialog.version"
          :footer="false"
          closeBtn
          class="activity-dialog "
        >
          <div class="activity-template-content " >
            <div class="title">温馨提示</div>
            <div class="content">
              <p>为向您提供更贴心顺畅的权益卡服务，请至AppStore更新「天美钱包」至V1.7.8及以上版本</p>
            </div> 
            <div class="button-group">
              <!-- <nd-button class="btn" @click="upgrade">立即升级</nd-button> -->
              <!-- <div class="giveup-btn" @click='dialog.version=false'>暂不升级 </div> -->
            </div>
          </div>
        </nd-dialog>
      </div>
    </pulldown-page>
  </div>
</template>

<script>
import { getKey, initGId, judgeClientSystem, versionStringCompare } from '../../assets/utils'
import pkg from '../../../package.json'
import { mapActions, mapMutations } from 'vuex'
import { Tab, Tabs, Swipe, SwipeItem } from 'vant'
import icon from './images/icon_vip_fangkuan.png'
import iconVip from './images/icon_vip.png'
import iconVip01 from './images/icon_vip_01.png'
import iconVip02 from './images/icon_vip_02.png'
import iconVip03 from './images/icon_vip_03.png'
import iconVip08 from './images/img_vip_08.png'
import iconVip09 from './images/img_vip_09.png' 
import iconVipHead from './images/icon_vip_head.png'
import { generateUUID } from '../../services/stat'
import { Base64 } from 'js-base64' 
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
import RefundBox from '@/components/refund-box'
import qs from 'qs'
const deviceInfo = {
  terminal: getKey('terminal') || 'H5',
  appVersion: getKey('appVersion') || pkg.version,
  uuid: generateUUID()
}
export default {
  name: 'vip',
  customReadyNotify: true,
  data () {
    return {
      active: 0,
      icon,
      iconVip,
      iconVip01, 
      iconVip02, 
      iconVip03,
      iconVip08,
      iconVip09,
      iconVipHead,
      buyVipLv: 0,
      n: 0,
      time: 6,
      isVip: true,
      memberInfoList: [],
      creditLimitInfo: {},
      payStatusInfo: {},
      orderListPending: false,
      pending: false,
      detail: {
      },
      welfareType: 'COUPON',
      memberNo: '',
      refundData: {
        refundShow: false,
        refunding: false,
        refundWay: 'APPLY'
      },
      welfares: {
        COUPON: {
          name: '免息返现',
          desc: `
                          1.  月卡20元*1张，半年卡20元*3张，年卡20元*6张 <br>
                          2.  每张券可享免息额度1000元，减免最后2期利息<br>
                          3.  最高返现金额120元
                        `,
          max: '最高120元'
        },
        LIMIT: {
          name: '专属提额',
          desc: `
                          1. 提升额度：月卡500元*1次，半年卡1000元*3次，年卡1000元*6次，最高可提额6000元<br>
                          2. 提额规则：月卡有效期内1次，半年卡和年卡自购卡日起，每两个月1次
                        `,
          max: '最高6000元'
        },
        CASH: {
          name: '拒就赔特权',
          desc: `
                          1. 赔付金额：月卡最高15元，半年卡最高50元，年卡最高100元<br>
                          2. 赔付规则：购买会员至会员失效，用户从未授信或者提现申请成功
                        `,
          max: '最高100元'
        },
        hot: {
          name: '热门会员VIP',
          desc: `
                          1. 热门会员十选一，每月免费领取1次（腾讯，爱奇艺，优酷，芒果，B站，QQ音乐，网易云音乐，酷狗音乐，喜马拉雅，饿了么会员）<br>
                          2. 月卡最高省30元，半年卡最高省180元，年卡最高省360元
                        `,
          max: '最高省360元'
        },
        trip: {
          name: '出行优惠',
          desc: `
                          1. 5元买10元滴滴快车券；或5元买25元哈啰单车骑行月卡；或5元买20元青桔单车骑行月卡<br>
                          2. 每月可折扣价格购买1次
                        `,
          max: '低至2折'
        },
        more: {
          name: '更多优惠',
          desc: `
                          1. 5折电影：25元买50元电影券（E票电影）<br>
                          2. 话费优惠充值：20元充值30元话费<br>
                          3. 每个月可享1次优惠
                        `,
          max: ''
        }
      },
      vipInfomation: {},
      vips: ['BC_M', 'BC_HY', 'BC_Y'],
      newType: ['EC_M', 'EC_HY', 'EC_Y'],
      vipActive: {
        'BC_M': '0', 
        'BC_HY': '1', 
        'BC_Y': '2'
      },
      vipsName: {
        'BC_M': '月卡', 
        'BC_HY': '半年卡', 
        'BC_Y': '年卡'
      },
             
      dialog: {
        vipPast: false, // vip 过期弹窗
        detention: false, // 返回挽留
        coupon: false, // 免息券授信
        quota: false, // 额度券授信
        welfare: false, // 权益介绍
        waitPay: false, // 等待支付中订单弹窗
        version: false // ios 版本过低提示 
      },
      gid: '',
      device: '',
      token: '',
      source: '',
      showPoint: !!localStorage.getItem('oldRule')
    }
  },
  mounted () {
    if (hasNativeMethod('getUserInfo') && judgeClientSystem() === 'IOS' && 
      deviceInfo.appVersion && (versionStringCompare('1.7.8', deviceInfo.appVersion) > 0)) {
        this.dialog.version = true
      }
    // this.$report({
    //     id: 10002,
    //     args: { screen: 'page_vip' }
    // })
    this.init()
            
    initGId().then(id => {
      this.gid = id
    })
    this.device = Base64.encode(JSON.stringify(Object.assign({}, deviceInfo, {
      longitude: getKey('longitude') || '',
      latitude: getKey('latitude') || ''
    })))
    this.token = getKey('userInfo', 'token') || ''
  },
  watch: {
    active (val, oldVal) {
      if (oldVal) {
        this.$report({
          id: 10238,
          args: { position: val }
        }) 
      }
                
      if (!this.isVip) {
        this.detail = this.memberInfoList[val]
      }
    },
    'dialog.coupon' (val) {
      clearTimeout(window.timer)
      this.$report({
        id: 10244,
        args: { visible: Number(val) }
      }) 
    },
    'dialog.vipPast' (val) {
      this.$report({
        id: 10240,
        args: { visible: Number(val) }
      }) 
    },
    'dialog.welfare' (val) {
      this.$report({
        id: 10246,
        args: { visible: Number(val) }
      }) 
    },
    'dialog.detention' (val) {
      this.$report({
        id: 10240,
        args: { visible: Number(val) }
      }) 
    },
    'dialog.quota' (val) {
      clearTimeout(window.timer)
    }
  },
  beforeRouteEnter (to, from, next) {
    if (from.path.includes('vip') || from.path.includes('withdraw') || from.path.includes('authentication')) {
      next(vm => {
        vm.source = 'ndmicro'
      })
    } else {
      next()
    }
  },
  components: {
    'van-tab': Tab,
    'van-tabs': Tabs,
    'van-swipe': Swipe,
    'van-swipe-item': SwipeItem,
    swiper: () => import('./components/swiper'),
    RefundBox
  },
  methods: {
    ...mapActions('vip', ['vipInfo', 'getToken', 'vipLimitadjust', 'vipAdPrize', 'orderCancel', 'popInfo', 'queryCheckRefundX']),
    ...mapMutations('user', ['setUserInfo']),
    jumpRule () {
      if (!localStorage.getItem('oldRule')) {
        localStorage.setItem('oldRule', 'T')
      }
      this.$router.push('/vip/orule')
    },
    async init () {
      const res = await this.vipInfo({
        memberGoodsGroupCd: 'OLD'
      })
      this.$bus.$emit('ready')
      if (res.success && res.data) {
        this.isVip = res.data.myMemberInfo && !!res.data.myMemberInfo.memberNo
        this.memberNo = res.data.myMemberInfo && res.data.myMemberInfo.memberNo
        if (this.memberNo) {
          this.handleCheckRefund()
        }
        this.creditLimitInfo = res.data.creditLimitInfo || {}
        if (this.isVip) { 
          this.detail = res.data.myMemberInfo 
          this.buyVipLv = this.vipActive[this.detail.memberType]
          // this.dialog.vipPast = this.detail.memberStatus === 'EXPIRED'
          // this.detail.memberStatus = 'EXPIRED'
        } else {
          this.memberInfoList = res.data.memberInfoList || []
          this.detail = this.memberInfoList[this.active] || {}
        }
        this.payStatusInfo = res.data.payStatusInfo || {}
        this.getPpopInfo()
      }
      // this.time = 6
      // this.dialog.coupon = true
      // this.renderTime()
    },
    async giveup () {
      const res = await this.orderCancel({
        orderNo: this.payStatusInfo.orderNo
      })
      if (res.success) {
        this.init()
        this.dialog.waitPay = false
      }
    },
    async getPpopInfo () {
      const res = await this.popInfo({
        memberGoodsGroupCd: 'ENJOY'
      })
      if (res.success) {
        this.vipInfomation = res.data || {}
      }
    },
    giveupVipPass () {
      this.$report({
        id: 10248
      }) 
      this.dialog.vipPast = false
    },
    // 跳转会员购买页面
    async buy (active, type) {
      if (type === 'pass') {
        this.$report({
          id: 10241,
          args: { position: active }
        }) 
      }
      if (type === 'detention') {
        this.$report({
          id: 10243,
          args: { target: 1 }
        }) 
      }
      if (type === 'welfare') {
        this.$report({
          id: 10247,
          args: { target: 1 }
        }) 
      }
      const res = await this.vipInfo({
        memberGoodsGroupCd: 'OLD'
      })
      if (res.success) {
        let { payStatusInfo } = res.data || {}
        if (payStatusInfo && payStatusInfo.orderPayStatus && payStatusInfo.orderPayStatus === 'WAIT_PAY') {
          this.dialog.waitPay = true 
        } else {
          this.jump(active)
        }
      }
    },
    jump (active, discountPrice) {
      let price =
        this.vipInfomation.simpleList &&
        this.vipInfomation.simpleList[this.buyVipLv].discountPrice
      let { couponRecordId } = this.$route.query || {}
      let couponRecordIdObj = couponRecordId ? { couponRecordId } : {}
      let host = encodeURIComponent(window.location.href)
      let gid = localStorage.getItem('gid')
      let token = getKey('userInfo', 'token') || ''
      let device = Base64.encode(
        JSON.stringify(
          Object.assign({}, deviceInfo, {
            longitude: getKey('longitude') || '',
            latitude: getKey('latitude') || ''
          })
        )
      )
      const channel = getKey('channel') || ''
      const query = {
        memberType: this.newType[active],
        memberGoodsGroupCd: 'ENJOY',
        discountPrice: this.detail.discountPrice || price,
        payChanel: this.payStatusInfo.payChanel,
        ...couponRecordIdObj,
        host,
        gid,
        token,
        channel,
        device
      }
      const origin = process.env.VUE_APP_PAYURL
      const path = '/pay'
      window.location.href = `${origin}${path}?${qs.stringify(query)}`
      // this.$router.push({ path: '/vip/middle', query })
    },
    // 跳转查看订单页面
    async toOrderList () {
      this.$report({
        id: 10235
      })
      if (this.orderListPending) return
      this.orderListPending = true
      const res = await this.getToken({
        benefitType: 'LIFE'
      })
      if (res.success && res.data) {
        window.location.href = `${process.env.VUE_APP_OREDERLIST_URL}/?source=chongtian&user_token=JWT%20${res.data.jwtToken}&return_url=${encodeURIComponent(window.location.href)}`
      }
      this.orderListPending = false
    },
    // 用户挽留政策
    detention () {
      if (this.detail.memberStatus !== 'NORMAL') {
        this.dialog.detention = true
      } else {
        this.$report({
          id: 10243,
          args: { target: 2 }
        }) 
        this.back()
      }
    },
    async linkUrl (url, type) {
      if (!this.isVip) {
        this.welfareType = 'more'
        this.dialog.welfare = true
      }

      const _taget = type === 'DYYH' ? 3 : 4
      this.$report({
        id: 10237,
        args: { target: _taget }
      })
      if (this.detail.memberStatus === 'EXPIRED') {
        this.dialog.vipPast = true
        return
      }
      if (url) {
        this.pending = true
        const res = await this.getToken({
          benefitType: 'LIFE'
        })
        if (res.success && res.data) {
          window.location.href = `${url}&once=${res.data.onceToken}`
        }
        this.pending = false
      }
    },
    nextNode (item) {
      return this.nextNodeCommon(item)
    },
    judge (path) {
      if (hasNativeMethod('navigateTo') && !!path.native && judgeClientSystem() !== 'IOS') {
        jsBridge('navigateTo', { path: path.native, exitCurrent: true })
      } else {
        this.$router.push(path.h5)
      }
    },
    async showWelfare (type, item) {
      const _taget = {
        COUPON: 1,
        LIMIT: 2,
        CASH: 3
      }
      if (['COUPON', 'LIMIT', 'CASH'].includes(type)) {
        this.$report({
          id: 10236,
          args: { target: _taget[type] }
        })
      }
                
      if (this.isVip && this.detail.memberStatus === 'NORMAL') {
        /**
         * 免息红包
         * 跳转逻辑请查看 ./images/免息券跳转逻辑.png
         */
        if (type === 'COUPON') {
          if (item.memberCouponStatus === 'RECEIVED') {
            const _creditLimitInfo = this.creditLimitInfo || {}
            // const _creditStatus = _creditLimitInfo.creditStatus 
            // 授信额度<=0 弹窗
            this.n = item.discountTermCount
            if (['OCR',
                 'INFO',
                 'CREDIT'].includes(_creditLimitInfo.nextStep)) {
                   this.time = 6
                   this.dialog.coupon = true
                   this.renderTime()
                   return
                 }
            if (['REPAYING', 'REPAY'].includes(item.useAction)) {
              this.$router.push(`/quan/detail?couponRecordId=${item.couponRecordId}`)
              return
            }
                           
            this.judge(this.nextNode({ nextStep: item.useAction, relationId: item.stepRelationId }))
          } 
          // 跳历史
          if (['USE_FAIL', 'USED', 'TIMEOUT'].includes(item.memberCouponStatus)) {
            this.$router.push(`/quan/history`)
          }
          // 跳详情
          if (['USEING'].includes(item.memberCouponStatus)) {
            this.$router.push(`/quan/detail?couponRecordId=${item.couponRecordId}`)
          }
        }
        /**
         * 提额券状态展示
         */
        if (type === 'LIMIT') {
          if (item.memberCouponStatus === 'RECEIVED') {
            const res = await this.vipLimitadjust({
              couponSerialNo: item.couponRecordId
            })
            if (res.success && res.data) {
              if (res.data.jumpToLimit) {
                this.init()
              } else {
                this.time = 6
                this.dialog.quota = true
                this.renderTime()
                return
              }
            }
            return
          }
          if (['USED'].includes(item.memberCouponStatus)) {
            this.$router.push(`/quan/detail?couponRecordId=${item.couponRecordId}`)
          }
          if (['TIMEOUT'].includes(item.memberCouponStatus)) {
            this.$router.push(`/quan/history`)
          }
        }

        if (type === 'CASH') {
          this.$router.push(`/quan/detail?couponRecordId=${item.couponRecordId}`)
        } 
        return
      }
                 
      // 过期
      if (this.isVip && this.detail.memberStatus === 'EXPIRED') {
        if (type === 'CASH') {
          this.$router.push(`/quan/detail?couponRecordId=${item.couponRecordId}`)
        } else {
          // 续费弹窗
          this.dialog.vipPast = true
        }
        return
      }
      if (!this.isVip) {
        this.welfareType = type
        this.dialog.welfare = true
      }
    },
    routerToVipProtocol () {
      this.$report({
        id: 10019,
        args: { position: 1 }
      })
      this.dialog.welfare = false
      this.dialog.vipPast = false
      this.$router.push('/protocol/vip')
    },
    toCredit (type) {
      if (type === 'COUPON') {
        this.$report({
          id: 10245
        }) 
      }
      const _itemCoupon = this.detail.financeEquityList.find(item => {
        console.log(type, item.memberCouponType)
        return item.memberCouponType === type 
      })
      this.judge(this.nextNode({ nextStep: _itemCoupon.useAction, relationId: _itemCoupon.stepRelationId }))
    },
    back () {
      if (hasNativeMethod('navigateTo') && judgeClientSystem() !== 'IOS') {
        if (this.isVip) {
          return jsBridge('exit')
        } else {
          this.$router.push('/vip/preindex')
        }
      } else {
        if (this.isVip) {
          this.$router.push('/mine')
        } else if (this.source === 'ndmicro') {
          this.$router.go(-1)
        } else {
          this.$router.push({ path: '/vip/preindex', query: { type: this.type } })
        }
      }
    },
    renderTime () {
      if (this.time >= 1) { this.time-- }
      setTimeout(() => {
        this.renderTime()
      }, 1000)
    },
    upgrade () {
      window.location.href = 'itms-appss://apps.apple.com/cn/app/id1495567036'
    },
    // 检查是否可以退款
    async handleCheckRefund () {
      const { success, data } = await this.queryCheckRefundX({
        memberNo: this.memberNo
      })
      if (success) {
        this.refundData = data
      }
    }

  }
}
</script>

<style lang="less">
@import "../../assets/less/mixin.less";

.ovip-container{
  background-color: #1C2032;
  position: relative;
  .check-more{color: #CA965D; font-size: 26px;text-align: right;width: 100%;}

  .tabs{
    position:sticky;
    top:105px;
    z-index:1000;
  }
  .van-tab--active{
    color:white;
  }
    .line-through {
      text-decoration: line-through;
      &.yj {font-size: 20px;}
      }
    .text-center {text-align: center;}
    .van-tabs__wrap {
      &:after{
        display: none;
      }
    }
    .nd-navigation .center{ flex:1;text-align: right;}
    .rule-txt {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      padding: 0 20px;
    }
    .point::before{
    content:'';
    display: inline-block;
    width: 16px;
    height: 16px;
    background: #B31B1A;
    border-radius:50%;
  }
    .ui-bubble{
      background: #763E12; color: #fff;
      font-size: 20px; padding:4px 20px;position: relative;
      border-radius: 10px;
      vertical-align: top;
      &::after{
        content: "";
        width: 0;
        height: 0;
        border-top: 10px solid #763E12;
        border-right: 22px solid transparent;
        bottom: -10px;
        left:20px;
        position: absolute;
      }
    }
    &.isVip {
      .main-container {
        padding-bottom: 40px;
      }
    }
    .main-container {
      background: #1C2032;
      padding-top: 40px;
      padding-bottom: 250px;
      .order-title {
        display: flex;
        justify-content: space-between;
        padding: 0 90px 40px 40px;
        position: relative;
        span{
          height: 45px;
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 45px;
        }
        a {
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 40px;
        }
        .order-service{
          position: absolute;
          right: 40px;
          width: 36px;
          top: 2px;
        }
      }
      .user-container {
        display: flex;
        align-items: center;
        img{width: 80px; height: 80px; margin-right: 20px;}
        .user-info {
          b{
            height: 56px;
            font-size: 40px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 56px;
          }
          p {
            height: 32px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 32px;
          }
        }
      }
      .icon_vip  {
        position: absolute;
        right: 0;
        top:0;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #763E12;
        height: 70px;
        line-height: 70px;
        padding: 0 20px;
        text-align: center;
        border-bottom-left-radius: 40px;
        background: linear-gradient(90deg, #FEF6E4 0%, #FCD5AC 100%);
      }
      .vip-btn {
         position: absolute;
        right: 20px;
        top:40px;
        font-size: 30px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #763E12;
        height: 60px;
        line-height: 60px;
        padding: 0 30px;
        border-radius: 100px;
        text-align: center;
        background: linear-gradient(90deg, #FEF6E4 0%, #FCD5AC 100%);
      }
      .mini-title {
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
        line-height: 45px;
        margin: 0 auto 20px 40px;
        .small {
          font-size: 26px;
          font-weight: 400;
          color: #999999;
        }
      }
      .mt50 {margin-top: 50px;}
      .equity-container {
        width: 670px;
        height: 450px;
        background: url('./images/bg_vip_kuang.png') no-repeat;
        background-size: 100% 100%;
        border-radius: 40px;
        padding: 30px 40px;
        position: relative;
        overflow: hidden;
        color: #fff;
        margin: auto;
        h2 {
          font-size: 40px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 56px;
        }
        .desc {
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          height: 40px;
          color: #FFFFFF;
          line-height: 40px;
        }
        .equity-items {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          margin: 0 -40px;
          .item {
            width: 24%;
            height: 120px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            margin-top: 20px;
            line-height: 1em;
            .icon {
              width: 40px;
              height: 40px;
              margin-bottom:8px;
            }
            p {font-size: 20px;}
            span {font-size: 18px;}
          }
        }
      }
      .ui-title {
        font-size: 38px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFD8BC;
        line-height: 53px;
        text-align: center;
        padding-top: 40px;
        padding-bottom:30px ;
        i {
          display: inline-block;
          padding: 0 10px;
          &:after,&:before {
            display: inline-block;
            content: '';
            width: 34px;
            height: 7px;
            border-radius: 100px;
            transform:translateY(-10px) rotateZ(-60deg) ;
            background: #EEC5A2FF;
            margin:0 -5px ;
          }
        }
        & i:first-child{
          &::before{opacity: .3; transform:translateY(-10px) rotateZ(-60deg) scale(0.9); }
        
        }
        & i:last-child{
          &::after{opacity: .3; transform:translateY(-10px) rotateZ(-60deg) scale(0.9);}
        }
      }
      .finance-equity-items {
        display: flex;
        align-items: center;
        flex-direction: column;
        .item {
          width: 670px;
          height: 150px;
          background: linear-gradient(90deg, #FEF6E4 0%, #FCD5AC 100%);
          border-radius: 20px;
          padding: 10px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
          overflow: hidden;
          position: relative;
          &::before{
            content: "";
            position: absolute;
            width: 220px;
            height: 110px; 
            right: 10px;
            background:  linear-gradient(90deg, #f7d5b1 0%, #EFC6A4FF 100%);
            transform: rotateZ(-70deg);
            opacity: .7;
          }
          &:last-child{margin-bottom: 0;}
          .info-left {display: flex; 
          align-items: center;}
          .icon {
            width: 100px;
            height: 100px;
          }
          .info-container {
            margin-left: 30px;
            .title {
              font-size: 32px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #763E12;
              line-height: 45px;
            }
            p{
              height: 37px;
              font-size: 26px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #763E12;
              line-height: 37px;
            }
          }
          .control {display: flex;
            flex-direction: column;
            position: relative;
            align-items: flex-end;
            i {
              font-style: normal;
              font-size: 22px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 30px;
              background: linear-gradient(270deg, #D79663 0%, #E4B378 100%);
              border-radius: 23px;
              padding: 1px 15px;
            }
            span {
              height: 37px;
              font-size: 26px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #763E12;
              line-height: 37px;
              margin-top: 10px;
            }
          }
        }
      }
      .more-container {
        display: flex;
        justify-content: space-between;
        padding: 0 40px;
        .more-img {
         width:325px ; height:125px;
        }
      }
      .more-tips {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 40px;
        text-align: center;
      }
    }
    .btn-container {
      width: 100%;
      height: 230px;
      padding: 30px;
      background: #43476B;
      position: fixed;
      bottom: 0;
      display: flex;
      justify-content: space-around;
      flex-direction: column;
      align-items: center;
      .ui-bubble {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFD8BC;
        line-height: 33px;
        top: 0;right: 40px;
        position: absolute;
        background: #000;
        border-radius: 100px;
        padding:10px 20px;
        &:after {
           border-top: 10px solid #000;
        border-right: 22px solid transparent;
        }
      }
      .text {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
      .xy-active {color:#8EB2D8}
    }
    
    
    // .tips {text-align: center; margin-top: 20px;}
  .van-tabs {
      padding-top: 98px;
      font-size: 36px;
  }
  .van-tabs__wrap {
    height: 98px;
  }
  .van-ellipsis {
    margin-top: 23px;
    font-size:36px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    line-height:50px;
  }
  // .my-swipe .van-swipe-item {
  //   color: #fff;
  //   font-size: 20px;
  //   line-height: 150px;
  //   text-align: center;
  //   background-color: #39a9ed;
  // }
  
  
}

.activity-dialog {
    border-radius: 30px;
    &.cat .default-content {
      &::after{
        content: "";
        position: absolute;
        width:178px; height: 154px;
        background: url('./images/img_mao02.png') no-repeat;
        background-size: contain;
        top: -152px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    .default-content {
       background: linear-gradient(90deg, #FEF6E4 0%, #FCD5AC 100%) !important;
       .activity-template-content {
        width: 620px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 40px;
        
        .title {
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #763E12;
          line-height: 45px;
          text-align: center;
        }
        .content {
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #763E12;
          line-height: 37px;
          padding: 20px 0;
        }
        .btn{
          width: 440px;
          height: 74px;
          line-height: 74px;
          margin-top: 30px;
          background: linear-gradient(270deg, #D79663 0%, #E4B378 100%);
        }
        .giveup-btn{
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #763E12;
          line-height: 40px;
          text-align: center;
          margin-top: 30px;
        }
        .xy-tips {
          color: #763E12;
          text-align: center;
          margin-top: 30px;
          .active {
            color: #763E12;
            text-decoration: underline;
          }
        }
        .vips {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          padding: 20px 0;
          .vipIcon {
            width: 64px;height: 24px;
          }
          .item {
            width: 154px;
            height: 200px;
            background: #FFFCEB;
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            text-align: center;
            padding: 20px 0;
            border: 1px solid #FBBF7C;
            position: relative;
            &:after {
              content: "";
              position: absolute;
              right: -18px;
              bottom: -18px;
              width: 36px; height: 36px;
              background: url('./images/circle_b.png') no-repeat;
              background-size: 100% 100%;
            }
            p {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #763E12;
              line-height: 33px;
            }
            &.active {
              background: #FFF2CB;
              border: 3px solid #FBBF7C ;
              &:after {
                background-image: url('./images/circle_a.png') 
              }
            }
          }
        }
        .step {
          p {
            padding-bottom: 30px ;
            i {
              background: #763E12;
              font-style: normal;
              width: 40px;
              height: 40px;
              line-height: 40px;
              display: inline-block;
              text-align: center;
              border-radius: 100%;
              color: #FFFCEB;
              position: relative;
              &.line::after{
                content: "";
                position: absolute;
                width: 2px;
                height: 20px;
                background: #D79663;
                font-size: 0;
                left:50%; 
                top: 45px
              }
            }
          }
        }
      }
    }
}
 
</style>
